import {
  GET_ADMIN_REFUND_REASON,
  GET_ADMIN_REFUND_REASON_SUCCESS,
  POST_ADMIN_REFUND_REASON,
  POST_ADMIN_REFUND_REASON_SUCCESS,
  POST_ADMIN_REFUND_REASON_ERROR,
  UPDATE_ADMIN_REFUND_REASON,
  UPDATE_ADMIN_REFUND_REASON_SUCCESS,
  UPDATE_ADMIN_REFUND_REASON_ERROR,
  DELETE_ADMIN_REFUND_REASON,
  DELETE_ADMIN_REFUND_REASON_SUCCESS,
  DELETE_ADMIN_REFUND_REASON_ERROR,
} from "./actionTypes"

export const getAdminRefundReason = (query_params) => {
  return {
    type: GET_ADMIN_REFUND_REASON,
    payload: query_params
  }
}

export const getAdminRefundReasonError = (event) => ({
  type: GET_ADMIN_REFUND_REASON_SUCCESS,
  payload: event
})

export const getAdminRefundReasonSuccess = (event) => ({
  type: GET_ADMIN_REFUND_REASON_SUCCESS,
  payload: event
})

export const postAdminRefundReason = (query_params) => {
  return {
    type: POST_ADMIN_REFUND_REASON,
    payload: query_params
  }
}

export const postAdminRefundReasonSuccess = (event) => ({
  type: POST_ADMIN_REFUND_REASON_SUCCESS,
  payload: event
})

export const postAdminRefundReasonError = (error) => ({
  type: POST_ADMIN_REFUND_REASON_ERROR,
  payload: error
})

export const updateAdminRefundReason = (query_params) => {
  return {
    type: UPDATE_ADMIN_REFUND_REASON,
    payload: query_params
  }
}

export const updateAdminRefundReasonSuccess = (event) => ({
  type: UPDATE_ADMIN_REFUND_REASON_SUCCESS,
  payload: event
})

export const updateAdminRefundReasonError = (error) => ({
  type: UPDATE_ADMIN_REFUND_REASON_ERROR,
  payload: error
})

export const deleteAdminRefundReason = (query_params) => {
  return {
    type: DELETE_ADMIN_REFUND_REASON,
    payload: query_params
  }
}

export const deleteAdminRefundReasonSuccess = (event) => ({
  type: DELETE_ADMIN_REFUND_REASON_SUCCESS,
  payload: event
})

export const deleteAdminRefundReasonError = (error) => ({
  type: DELETE_ADMIN_REFUND_REASON_ERROR,
  payload: error
})

